import { first } from 'lodash';
import { useParams } from 'react-router-dom';

import { Education } from '@/modules/education/Education';
import { EducationSlideOverridesProvider } from '@/modules/education/EducationSlideOverrides/EducationSlideOverrides.context';
import { TenantPresentationConfigurationProvider } from '@/modules/presentation/context/TenantPresentationConfiguration.provider';
import { useTenantDisclaimerConfigurationQuery } from '@/modules/presentation/graphql/TenantPresentationConfiguration.generated';
import { getNodes } from '@/utils/graphqlUtils';

export function EducationPage() {
  const { householdId } = useParams();
  const { data, loading } = useTenantDisclaimerConfigurationQuery({
    variables: {
      householdID: householdId,
      hasHouseholdID: Boolean(householdId),
    },
    skip: !householdId,
  });

  if (!householdId) {
    throw new Error(`No householdId provided.`);
  }

  const household = first(getNodes(data?.households));
  const subBrandId =
    loading && !data ? undefined : (household?.subBrand?.id ?? null);

  return (
    <TenantPresentationConfigurationProvider subBrandId={subBrandId}>
      <EducationSlideOverridesProvider>
        <Education householdId={householdId} />
      </EducationSlideOverridesProvider>
    </TenantPresentationConfigurationProvider>
  );
}
